import { useMutation, useQueryClient } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'

interface UpsertConfigurationParams {
  customerId: string
  key: string
  value: Record<string, unknown> | boolean
}

export default function useUpsertCustomerConfiguration() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      customerId,
      key,
      value,
    }: UpsertConfigurationParams) => {
      const response = await epsClient.put(
        `/customers/${customerId}/configurations/${key}`,
        { value }
      )
      return response.data
    },
    onSuccess: (_data, { customerId }) => {
      queryClient.invalidateQueries({
        queryKey: ['customerConfigurationInventory', customerId],
      })
    },
  })
}
